/**
 * Core Web Vitals collection (AXI-3875).
 *
 * Wraps the `web-vitals` library's `onX` handlers, which each fire once when
 * their metric is finalized (LCP/CLS/INP at page hide, FCP/TTFB early), and
 * forwards the value to the collector tagged with the route that was mounted
 * at report time. Idempotent — safe to call once from the app entry.
 */
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals'
import { enqueueBeacon } from './collector-client'
import { getCurrentRouteLabel } from './navigation-timing'
import type { WebVitalName, WebVitalRating } from './types'

let started = false

function report(metric: Metric): void {
  enqueueBeacon({
    kind: 'web-vital',
    name: metric.name as WebVitalName,
    value: metric.value,
    rating: metric.rating as WebVitalRating,
    route: getCurrentRouteLabel()
  })
}

/** Register the five Core Web Vitals listeners. No-op after the first call. */
export function initWebVitals(): void {
  if (started || typeof window === 'undefined') return
  started = true
  onLCP(report)
  onCLS(report)
  onINP(report)
  onFCP(report)
  onTTFB(report)
}
